import { Component } from '@angular/core';
import { WiperLoadingComponent } from '../../../wiper-loading/wiper-loading.component';

@Component({
  selector: 'app-head-wiper',
  imports: [WiperLoadingComponent],
  templateUrl: './head-wiper.component.html',
  styleUrl: './head-wiper.component.scss',
})
export class HeadWiperComponent {}
